import { Pipe, PipeTransform } from '@angular/core';
import { DuctMapping } from '../../span-progress-entities';

@Pipe({
  name: 'filterDuctMappings',
  standalone: false,
})
export class DuctSearchPipe implements PipeTransform {
  transform(ductData: DuctMapping[], input: string | null, spanId?: string) {
    let filteredDucts: DuctMapping[] = [];
    if (spanId) {
      filteredDucts = ductData.filter((duct) => {
        return duct.spanIds.toLocaleString().includes(spanId);
      });
    } else if (input && input.length) {
      input = input.toLocaleLowerCase();
      filteredDucts = ductData.filter((duct) => {
        if (input) {
          return (
            duct.name.toLocaleLowerCase().includes(input) ||
            duct.serialNumber.toLocaleLowerCase().includes(input) ||
            duct.colorName.toLocaleLowerCase().includes(input)
          );
        }
      });
    }
    return input?.length ? filteredDucts : ductData;
  }
}
